import L from 'leaflet';
import Vue from 'vue';
import chat_messages from './chat-messages';
import MediaManager from '../../lib/controller-ws/media-manager';

import {_names as M} from '../mutation-types';
import eventBus from '../../lib/eventBus';

let media_manager;

export default {
	namespaced: true,

	modules: {
		chat_messages,
	},
	state: {
		connected: false,

		incident_id: undefined,

		answered_by: undefined,
		transfer_to: undefined,
		disconnected_by: undefined,

		status: undefined,

		sent_answer_request: false,

		localMedia: undefined,
		sdpOffer: undefined,
		sdpAnswer: undefined,
		iceCandidates: [],

		locations: [],
	},
	getters: {
		is_ringing(store) { // TODO make constant
			return store.status === 'new'; // TODO implement transfer || store.status === 'TRANSFER'
		},

		map_markers(state) {
			let markers = [];

			if (state.locations.length > 0) {
				let lastLocation = state.locations[state.locations.length - 1];

				let icon = new L.Icon({
					iconUrl: require('../../assets/caller.png'),
					iconSize: [32, 37],
					iconAnchor: [16, 37],
				});

				markers.push({
					icon,
					position: lastLocation,
					tooltip: 'User Location',
				});

			}

			Vue.nextTick().then(function() {
				eventBus.$emit('recenter-map');
			});

			return markers;
		}
	},
	actions: {
		try_answer_call({state, commit, rootState}) {
			if (state.answered_by && state.answered_by !== '') {
				return;
			}

			// TODO handle transfers

			if (state.sent_answer_request) {
				// TODO log? show error?
				console.log('already sent answer request');
				return;
			}

			media_manager = new MediaManager({
				remoteMediaEl: 'remoteVideo',
				localMediaEl: 'localAudio',
				debug: true,
			});

			var webrtc_callback = () => {
				commit('answer');
			};
			media_manager.emit('webrtc.easy_connect', webrtc_callback);
		},
	},
	mutations: {
		set_local_media(state, media) {
			state.localMedia = media;
		},
		set_sdp_offer(state, offer) {
			state.sdpOffer = offer;
		},
		set_sdp_answer(state, answer) {
			state.sdpAnswer = answer;
		},
		add_ice_cadidate(state, candidate) {
			state.iceCandidates.push(candidate);
		},
		answer(state) {
			state.sent_answer_request = true;
		},
		set_connected(state, isConnected) {
			state.connected = isConnected;
		},
		update_status(state, message) {
			state.incident_id = message.incidentNumber;
			state.transfer_to = message.transfer;
			state.answered_by = message.answerer;
			state.disconnected_by = message.disconnectedBy;

			if (message.disconnectedBy !== '') {
				eventBus.$emit('controller.hangup');
				return;
			}

			if (state.transfer_to && state.transfer_to.length > 0) {
				// TODO handle transfers
				return;
			}

			// if (state.answered_by === '') {
			// 	// TODO TRY TO ANSWER THE CALL HERE
			// } else if (state.answered_by === state.getters['operator/controllerUserId']) {
			// 	// TODO WE GOT IT
			// } else {
			// 	// TODO SHOW ERROR SOMEONE ELSE GOT IT
			// }
		},
		endCall() {
			// NOOP in here.
			// Used to trigger the end of a call through the WebSocket plugin.
		},
		[M.videoCall.UPDATE_USER_LOCATION](state, loc) {
			state.locations.push(loc);
		},
	},
};
